function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-v-3e4bb0d2": "",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  "data-v-3e4bb0d2": "",
  transform: "translate(0.000000, -632.000000)",
  fill: "rgba(0,0,0,0.5)"
}, React.createElement("path", {
  "data-v-3e4bb0d2": "",
  d: "M0,632 L375,632 L375,1122 L0,1122 L0,632 Z M248.868742,958.117139 L251.883562,887.49964 L243.969659,887.49964 C242.839101,916.988266 239.447429,920.092332 221.358508,920.092332 L148.249119,920.092332 L212.6909,849.862841 C239.447429,820.762224 251.883562,804.077869 251.883562,775.753268 C251.883562,740.444519 221.358508,716 188.572338,716 C153.525054,716 126.768525,736.952445 126.768525,772.649202 C126.768525,780.409367 132.04446,806.405919 153.901907,806.405919 C163.32322,806.405919 174.251943,799.809779 174.251943,783.513433 C174.251943,768.76912 162.569515,762.948997 157.293579,762.948997 C144.480594,762.948997 144.857446,766.829079 142.219479,766.829079 C138.450953,766.829079 137.320396,764.113021 137.320396,759.844931 C137.320396,752.472774 146.741709,730.356305 170.483418,730.356305 C196.486241,730.356305 204.400144,757.128873 204.400144,779.245342 C204.400144,820.374215 193.848274,856.458981 123,937.940711 L123,958.117139 L248.868742,958.117139 Z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-v-3e4bb0d2": "",
    "data-v-59251244": "",
    width: "375px",
    height: "490px",
    viewBox: "0 0 375 490",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mask2.ebc00553.svg";
export { SvgComponent as ReactComponent };